import {createSlice} from "@reduxjs/toolkit";
import { getRoleList } from './action';

const initialState = {
  state: {
    items: [],
    paging: {}
  },
  loading: true,
  error: ''
} as BaseState<RoleState>

const slice = createSlice({
  name: 'rolesSlice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getRoleList.pending, (state) => ({
        ...state,
        loading: true
      })
    )
    builder.addCase(getRoleList.fulfilled, (state, action) => {
        const { items, paging } = action.payload
        return {
          state: { items, paging },
          loading: false,
          error: null
        }
      }
    )
    builder.addCase(getRoleList.rejected, (state) => ({
        ...state,
        loading: false,
        error: 'Failed to get roles, please try again'
      })
    )
  }
})

export default slice
